import regex from '../regex'

/**
 * Custom validator for valid house number
 * @param {String} value | input value
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const houseNumber = function (value, options) {
  const validHouseNumber =
    value &&
    regex.houseNumberRegex.test(value) &&
    value.length <= 10 &&
    !value.slice(-1).match(/[a-zA-Z]/i)
  if (!validHouseNumber) {
    return options.message
  }
  return null
}
export default houseNumber
